import {useQuery} from '@apollo/client';
import {Box, Stack, Text, Title} from '@mantine/core';
import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import type {GetScientificModels} from './__generated/GetScientificModels';
import {ScientificModelCard} from './ScientificModelCard';
import {GET_SCIENTIFIC_MODELS_QUERY} from './ScientificModelsQueries';

export function ScientificModelsView(): JSX.Element {
  const {data, loading, error} = useQuery<GetScientificModels>(GET_SCIENTIFIC_MODELS_QUERY);

  if (loading) {
    return (
      <Stack p="md">
        <Title order={3}>Scientific Models</Title>
        <Text>Loading models...</Text>
      </Stack>
    );
  }

  if (error) {
    return (
      <Stack p="md">
        <Title order={3}>Scientific Models</Title>
        <Text color="red">Error loading models: {error.message}</Text>
      </Stack>
    );
  }

  const models = data?.scientificModels ?? [];

  return (
    <Box className={css(styles.container)}>
      <Stack spacing="md" style={{width: '100%'}}>
        <Title order={3}>Scientific Models</Title>
        <div className={css(styles.modelsGrid)}>
          {models.map((model) => (
            <ScientificModelCard
              key={model.systemName}
              systemName={model.systemName}
              displayName={model.displayName}
              iconPath={model.iconPath}
              category={model.category}
            />
          ))}
        </div>
      </Stack>
    </Box>
  );
}

const styles = StyleSheet.create({
  container: {
    padding: '16px',
    width: '100%',
    maxWidth: '100%',
  },
  modelsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: '15px',
    width: '100%',
    maxWidth: '600px',
    '@media (max-width: 768px)': {
      gridTemplateColumns: 'repeat(2, 1fr)',
    },
    '@media (max-width: 480px)': {
      gridTemplateColumns: '1fr',
    },
  },
});
